import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import InputField from '../../../../reusable-components/InputField';
import { required } from '../../../../utils/validations';
import Woonboot from './Woonboot';
import Steiger from './Steiger';
import Boat from './Boat';
import PropTypes from 'prop-types';

class ChooseObject extends Component {
  constructor(props){
    super(props);
  }

  onSubmit = (values) => {
    const { saveObject, history } = this.props;
    let cleanedLength = values.object_length.replace(',', '.')
    let cleanedWidth = values.object_width.replace(',', '.')
    values.object_length_m = (cleanedLength / 100).toFixed(2)
    values.object_width_m = (cleanedWidth / 100).toFixed(2)
    saveObject(values);
    history.push('/extend/GetCosts');
  }

  render() {
    const { handleSubmit, pristine, submitting, isloading, formErrors, selectedObjectName, history } = this.props;

    let content = null;

    if (selectedObjectName === 'Boat') {
      content = <Boat {...this.props} onSubmit={this.onSubmit}/>
    } else if (selectedObjectName === 'Woonboot') {
      content = <Woonboot {...this.props} onSubmit={this.onSubmit}/>
    } else if (selectedObjectName === 'Steiger') {
      content = <Steiger {...this.props} onSubmit={this.onSubmit}/>
    } else {
      history.push('/extend/ChooseObject');
      // content = <Boat {...this.props} onSubmit={this.onSubmit}/>
    }

    return (
      <>
        {content}
      </>
    );
  }
}

ChooseObject.propTypes = {
  isloading: PropTypes.bool,
  initialValues: PropTypes.object,
  formErrors: PropTypes.object
}

export default ChooseObject;

